import React from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function Directories() {
  const {
    currentView,
    fileManagerFilters,
    getFiles,
    breadCrumbs,
    setBreadCrumbs,
    filterBreadCrumbs,
    onFilterChange,
    pageLimit,
    isGlobalFileManager,
    caseDetails,
    isClientFileManager,
    query,
  } = useFileManagerContext();

  const home = {
    icon: 'pi pi-home',
    command: (e) => {
      const obj = {
        case_id: isGlobalFileManager || isClientFileManager ? fileManagerFilters.case : caseDetails.case_id,
        selectedFolder: '',
        selectedType: fileManagerFilters.fileType,
        tag: fileManagerFilters.tag,
        query: query,
        folder_id: 'home',
        // Reset shared_folder to false when going to Home for proper client view
        shared_folder: false,
      };
      getFiles(obj, currentView, pageLimit);
      const data = {
        target: {
          name: 'selectedFolder',
        },
        value: '',
        shared_folder: false,
      };
      onFilterChange(data, clearBreadcrumbs);
    },
  };

  const clearBreadcrumbs = () => {
    setBreadCrumbs([]);
  };

  const breadcrumbModel = breadCrumbs?.map((item) => {
    return {
      ...item,
      command: (e) => {
        const obj = {
          case_id: isGlobalFileManager || isClientFileManager ? fileManagerFilters.case : caseDetails.case_id,
          selectedFolder: e.item.value,
          selectedType: fileManagerFilters.fileType,
          tag: fileManagerFilters.tag,
          query: query,
          folder_id: e.item.value,
          // Preserve shared_folder flag for breadcrumb navigation
          ...(fileManagerFilters?.shared_folder && { shared_folder: fileManagerFilters.shared_folder }),
        };
        getFiles(obj, currentView, pageLimit);
        filterBreadCrumbs(e.item.value);
      },
    };
  });

  return (
    <div className="file-path-containter d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12">
        <label className="p-medium">Directory Path</label>
      </div>
      <div className="col-md-8 col-12">
        <BreadCrumb model={breadcrumbModel} home={home} />
      </div>
    </div>
  );
}

export default Directories;
